<template>
<div>
  <v-dialog class="send-mail-dialog" persistent scrollable v-model="dialogOpen" id="sendMailForm">
    <v-card>
      <v-progress-linear :indeterminate="true" v-if="sending"></v-progress-linear>
      <v-card-title>
        <v-btn flat icon class="close-button" @click.stop="close()" v-show="!finished">
          <i class="close material-icons">clear</i>
        </v-btn>
        <v-layout wrap>
          <v-flex xs10>
            <img src="@/assets/img/icons/participe.svg" class="asu-title-icon"/>
            <span class="asu-title">{{ title }}</span>
          </v-flex>
          <v-flex xs12>
            <span class="description" v-show="!noSendByError && showTipoReclamoPanel">Seleccione un tipo de Reclamo</span>
            <span class="description" v-show="!noSendByError && !showTipoReclamoPanel">{{description}}</span>
          </v-flex>
          <v-flex xs4>
            <ayuda-button @on-click="openGuiaParticipacion()" v-show="!finished"/>
          </v-flex>
          <v-flex xs12 v-if="showTipoReclamoPanel">
            <div class="reclamos-header-container">
              <span class="asu-title">Reclamos frecuentes</span>
              <v-text-field
                color="primary"
                label="Buscar..."
                v-model="filterText"
                :disabled="sending"
                @keyup="filterTiposReclamoList"
              ></v-text-field>
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex v-if="showTipoReclamoPanel">
            <v-list>
              <template v-for="(tipoReclamo, index) in tiposReclamoListFiltered">
                <template v-if="tipoReclamo.items">
                  <v-list-group :key="getReclamoKey(tipoReclamo.name, index)">
                    <template v-slot:activator>
                      <v-list-tile ripple>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <i class="material-icons">menu</i>
                            <span class="v-list-tile-text">{{ tipoReclamo.name }}</span>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                    <template v-for="(item, idx) in tipoReclamo.items">
                      <v-list-tile ripple :key="`reclamo-${getReclamoKey(item.name, idx)}`" @click.stop="setTipoReclamoInForm(tipoReclamo, item)">
                        <v-list-tile-content>
                          <div class="v-list-tile-text">
                            <span>{{item.name}}</span>
                          </div>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <i class="material-icons project-button-icon">keyboard_arrow_right</i>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider :key="`divider-${idx}`"></v-divider>
                    </template>
                  </v-list-group>
                </template>
                <template v-else>
                  <v-list-tile ripple :key="getReclamoKey(tipoReclamo.name, index)" @click.stop="form.tipoReclamo = tipoReclamo.name">
                    <v-list-tile-content>
                      <div class="v-list-tile-text">
                        <span>{{ tipoReclamo.name }}</span>
                      </div>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <i class="material-icons project-button-icon">keyboard_arrow_right</i>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
                <v-divider :key="`divider-${index}`"></v-divider>
              </template>
              <v-list-tile ripple @click.stop="form.tipoReclamo = 'Otro'">
                <v-list-tile-content>
                  <div class="v-list-tile-text">
                    <span>Otro</span>
                  </div>
                </v-list-tile-content>
                <v-list-tile-action>
                  <i class="material-icons project-button-icon">keyboard_arrow_right</i>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
          <v-flex v-if="!showTipoReclamoPanel">
            <div v-if="finished">
              <div v-if="noSendByError" >
                Error al enviar su reclamo.
                <br/>
                <br/>
                Disculpe los inconvenientes
              </div>
              <div v-else >
                Mensaje enviado!
                <br/>
                <br/>
                Gracias por comunicarte con nosotros.
                <br/>
                <br/>
                Nos comunicaremos contigo tan pronto nos sea posible!
                <br/>
                <br/>
              </div>
            </div>
            <form v-else @submit.prevent="validateForm()" enctype="multipart/form-data">
              <v-radio-group v-model="form.messageType" :disabled="sending" row>
                <template v-for="(item, idx) in messageTypeOptions">
                  <div :key="`message-type-content-${idx}`">
                    <div :key="`message-type-icon-${idx}`" class="ap-comment-icon">
                      <i class="material-icons" :class="[item.clazz]" style="color:rgb(13, 37, 99)" :style="{'font-size': item.fontSize}">
                        {{item.content}}
                      </i>
                    </div>
                    <v-radio
                      :key="`message-type-radio-${idx}`"
                      :label="item.name"
                      :value="item.name"
                      color="error"
                    ></v-radio>
                  </div>
                </template>
              </v-radio-group>

              <v-text-field
                required
                color="primary"
                label="Nombre"
                v-model="form.name"
                :disabled="sending"
                :error-messages="getMessageErrors('form.name')"
                @input="$v.form.name.$touch()"
                @blur="$v.form.name.$touch()"
              ></v-text-field>

              <v-text-field
                required
                color="primary"
                label="Correo electrónico"
                v-model="form.email"
                :disabled="sending"
                :error-messages="getMessageErrors('form.email')"
                @input="$v.form.email.$touch()"
                @blur="$v.form.email.$touch()"
              ></v-text-field>

              <custom-select-group
                v-if="form.messageType === 'Reclamo'"
                color="primary"
                label="Tipo de Reclamo"
                :items="tiposReclamoList"
                v-model="form.tipoReclamo"
                item-text="name"
                item-value="name"
                :error-messages="getMessageErrors('form.tipoReclamo')"
                :disabled="sending"
                @input="$v.form.tipoReclamo.$touch()"
                @blur="$v.form.tipoReclamo.$touch()"
              ></custom-select-group>

              <v-text-field
                v-if="form.messageType === 'Reclamo' && form.tipoReclamo === 'Otro'"
                required
                color="primary"
                label="Tipo de Reclamo"
                v-model="form.tipoReclamoOtro"
                :disabled="sending"
                :error-messages="getMessageErrors('form.tipoReclamoOtro')"
                @input="$v.form.tipoReclamoOtro.$touch()"
                @blur="$v.form.tipoReclamoOtro.$touch()"
              ></v-text-field>

              <v-text-field
                v-if="form.messageType === 'Otro'"
                required
                color="primary"
                label="Título"
                v-model="form.otroTitulo"
                :disabled="sending"
                :error-messages="getMessageErrors('form.otroTitulo')"
                @input="$v.form.otroTitulo.$touch()"
                @blur="$v.form.otroTitulo.$touch()"
              ></v-text-field>

              <v-textarea
                outline
                label="Mensaje"
                v-model="form.message"
                :error-messages="getMessageErrors('form.message')"
                :disabled="sending"
                @input="$v.form.message.$touch()"
                @blur="$v.form.message.$touch()"
              ></v-textarea>

              <custom-input-file
                label="Subir archivos..."
                v-model="form.filenames"
                :error-messages="messageErrorsByFile"
                :disabled="sending"
                @change-files="fileSelected"
                @input="$v.form.filenames.$touch()"
                @blur="$v.form.filenames.$touch()"
              ></custom-input-file>

              <v-btn type="submit" ref="submit" :disabled="sending" v-show="false"></v-btn>
            </form>
          </v-flex>
        </v-layout>

      </v-card-text>
      <v-card-actions :class="finished ? 'center':''">
        <div v-show="finished" class="center">
          <v-btn flat :disabled="sending" @click.stop="close()">Aceptar</v-btn>
        </div>
        <div v-show="!finished">
          <v-btn flat :disabled="sending" @click.stop="clickInSubmit" color="primary" v-if="!showTipoReclamoPanel">Enviar</v-btn>
          <v-btn flat :disabled="sending" @click.stop="close()">Cancelar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showSnackbarDialog">
    <v-snackbar v-model="showSnackbar" :timeout="5000">
      <span>¡Error en el formulario! No adjunte archivos de más de 5MB.</span>
      <v-btn color="pink" flat @click.stop="showSnackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-dialog>

</div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { email, minLength, required } from 'vuelidate/lib/validators'
import validationUtilsMixin from '@/mixins/validation-utils.js'
import tiposReclamo from '@/assets/json/entidadesEjecutoras.json'
import merge from 'deepmerge'

const thereExistFileGreaterThan50mb = files => files.find(file => file.fileSize > 5000000 || file.size > 5000000)

export default {
  components: {
    'ayuda-button': _ => import('./AyudaButton')
  },
  props: {
    title: String,
    description: String,
    open: {
      default: false,
      type: Boolean
    },
    projectInfo: Object,
    initialMessageType: {
      type: String,
      default: null
    }
  },
  mixins: [ validationUtilsMixin ],
  mounted () {
    this.updateProjectInfo()
    this.mergeTipoParticipacionInfo()
    this.dialogOpen = this.open
    this.form.messageType = this.initialMessageType
    this.listHeight = this.computeListHeight()
  },
  data () {
    return {
      dialogOpen: false,
      listHeight: 50,
      form: {
        name: null,
        email: null,
        message: null,
        messageType: null,
        tipoReclamo: null,
        tipoReclamoOtro: null,
        otroTitulo: null,
        filenames: null, // used to show the names of the files to upload
        archivos: [] // the container for files
      },
      success: false,
      finished: false,
      userSaved: false,
      lastUser: null,
      showSnackbar: false,
      showSnackbarDialog: false,
      noSendByError: false,
      messageTypeOptions: [],
      messageTypeOptionsDefault: [
        { name: 'Pedido de Documento', clazz: 'ap-Pedido-documento', fontSize: 'inherit', fontWeight: 'inherit' },
        { name: 'Comentario', clazz: 'ap-Comentario', fontSize: 'inherit', fontWeight: 'inherit' },
        { name: 'Reclamo', clazz: 'ap-reclamo', fontSize: 'large !important', fontWeight: 'inherit' },
        { name: 'Otro', fontSize: '2.5em !important', content: 'add', fontWeight: 'bold' }
      ],
      tiposReclamoList: [],
      tiposReclamoListFiltered: [],
      filterText: null
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      message: {
        required,
        minLength: minLength(10)
      },
      messageType: {
        required
      },
      latitude: {},
      longitude: {},
      tipoReclamo: {},
      tipoReclamoOtro: {},
      otroTitulo: {},
      filenames: {
        shouldBeLessThan50mb: (val, $v) => !thereExistFileGreaterThan50mb($v.archivos)
      },
      archivos: {}
    }
  },
  methods: {
    sendMessage (url, callback) {
      var self = this
      self.noSendByError = false
      this.createIssue({ http: self.$http, data: self.form })
        .then(data => {
          self.finished = true
          self.success = true
        })
        .catch(err => {
          if (err.status === 422) {
            self.showSnackbar = true
          } else {
            self.finished = true
            self.noSendByError = true
          }
        })
      /* const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random())
      window[callbackName] = function (data) {
        delete window[callbackName]
        document.body.removeChild(script)
        callback(data)
      }
      const script = document.createElement('script')
      script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName
      document.body.appendChild(script) */
    },
    clearForm () {
      this.$v.$reset()
      this.form.name = null
      this.form.email = null
      this.form.message = null
      this.form.messageType = null
      this.form.tipoReclamo = null
      this.form.tipoReclamoOtro = null
      this.form.otroTitulo = null
      this.form.filenames = null
      this.form.archivos = []
      this.tiposReclamoListFiltered = this.tiposReclamoList
      this.filterText = null
    },
    saveUser () {
      this.noSendByError = false
      const { email, name, message } = this.form
      const url = 'http://getsimpleform.com/messages/ajax?form_api_token=64985e2fdaef1d34a62f4fe3da5500bc'
      this.sendMessage(`${url}&name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&message=${encodeURIComponent(message)}`)
    },
    close () {
      this.success = false
      this.finished = false
      this.clearForm()
      this.$emit('update:open', false)
    },
    validateForm () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.saveUser()
      }
    },
    fillTiposReclamoList () {
      const other = { name: 'Otro' }
      if (!tiposReclamo.find(t => t.name === other.name)) tiposReclamo.push(other)
      this.tiposReclamoList = tiposReclamo
      this.tiposReclamoListFiltered = this.tiposReclamoList
      if (this.tiposReclamoList.length < 1) {
        this.form.tipoReclamo = 'Otro'
      } else {
        this.form.tipoReclamo = ''
      }
    },
    filterTiposReclamoList () {
      if (!this.tiposReclamoList) return
      if (!this.filterText) {
        this.tiposReclamoListFiltered = this.tiposReclamoList
        return
      }
      let filter = function me (arr, text) {
        let ret = []
        let textl = text.toLowerCase()
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].items) {
            let it = me(arr[i].items, text)
            if (it.length > 0) { ret.push({ name: arr[i].name, items: it }) }
          } else if (arr[i].name.toLowerCase().indexOf(textl) > -1) {
            ret.push(arr[i])
          }
        }
        return ret
      }
      this.tiposReclamoListFiltered = filter(this.tiposReclamoList, this.filterText)
    },
    updateProjectInfo () {
      var pi = this.projectInfo
      if (pi && pi.id) {
        this.tiposReclamoList = []
        this.form.project_id = pi.id
        this.form.latitude = pi.mapProperties.mapIconPosition[1]
        this.form.longitude = pi.mapProperties.mapIconPosition[0]
        this.fillTiposReclamoList()
      }
    },
    mergeTipoParticipacionInfo () {
      if (!this.trackers || !this.trackers.length) return
      this.trackers.forEach(option => {
        this.messageTypeOptionsDefault.forEach(defOption => {
          if (option.name === defOption.name) {
            this.messageTypeOptions.push(merge(defOption, option))
          }
        })
      })
    },
    fileSelected (fileList) {
      this.form.archivos = fileList || []
    },
    computeListHeight () {
      let el = document.getElementById('sendMailForm')
      if (el) return el.clientHeight - 120
      return 20
    },
    openGuiaParticipacion () {
      this.$emit('on-help-click')
    },
    ...mapActions([
      'createIssue'
    ]),
    getReclamoKey (reclamo, index) {
      return reclamo ? reclamo.replace(/ /g, '_') : `reclamo-key-${index}`
    },
    clickInSubmit () {
      this.$refs.submit && this.$refs.submit.$el && this.$refs.submit.$el.click()
    },
    setTipoReclamoInForm (tipoReclamo, item) {
      this.form.tipoReclamo = `${item.name}`
    }
  },
  computed: {
    ...mapGetters({
      trackers: 'getTrackers'
    }),
    getMessageType () {
      return this.form.messageType
    },
    showTipoReclamoPanel () {
      return this.form.messageType === 'Reclamo' && this.tiposReclamoList.length > 0 && !this.form.tipoReclamo
    },
    messageErrorsByFile () {
      if (!this.$v.form.filenames.$dirty) return []
      const errors = this.getMessageErrors('form.filenames')
      !this.$v.form.filenames.shouldBeLessThan50mb && errors.push('El archivo debe pesar menos que 5MB')
      return errors
    }
  },
  watch: {
    projectInfo () {
      this.updateProjectInfo()
    },
    getMessageType () {
      if (this.form.messageType === 'Reclamo' && this.tiposReclamoList.length < 1) {
        this.form.tipoReclamo = 'Otro'
      } else {
        this.form.tipoReclamo = ''
      }
    },
    trackers () {
      this.mergeTipoParticipacionInfo()
      this.listHeight = this.computeListHeight()
    },
    open () {
      this.dialogOpen = this.open
      if (this.open) {
        this.form.messageType = this.initialMessageType
      }
    },
    initialMessageType () {
      this.form.messageType = this.initialMessageType
    },
    showSnackbar (val) {
      this.showSnackbarDialog = val
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/variables'

.asu-title
  color: rgb(13, 37, 99)
  font-weight: bold

.asu-title
  color: rgb(13, 37, 99)
  font-weight: bold
  font-family: 'Roboto Condensed', serif
  font-size: 2em
  font-weight: bold
  vertical-align: middle

.asu-title-icon
  width: $f85px

.description
  color: gray
  font-family: 'Roboto Condensed', serif
  font-size: $f20px
  font-weight: bold
  display: inline-block
  padding-bottom: $f15px

.success
  text-align: center
  font-size: 20px
  font-family: 'Roboto Condensed', serif

.v-card__title
  display: block
  padding-bottom: 0

.v-card__text
  padding-top: 0

.ap-comment-icon
  text-align: center
  padding-left: 24px

.ap-Pedido-documento, .ap-Comentario
  font-size: 1.5rem !important

form
  height: 100%
  box-sizing: border-box

.v-list >>> .v-list__tile--link
  min-height: 30px

.v-list__group
  & >>> .v-list__group__items
    padding-left: $f30px

.v-list-tile-text
  padding: $f5px 0
  width: 100%
  white-space: pre-wrap
  word-break: break-word

.v-progress-linear
  margin: 0

.close-button
  float: right

.v-dialog__content >>> .v-dialog.v-dialog--active
  min-width: $f280px
  max-width: 80%
  max-height: 80%
  .isMobile &
    width: 100vmax
    min-width: 100%
    max-width: 100%
    max-height: 100%
    margin-left: 0
    margin-right: 0
    .v-card
      padding-top: $f15px

</style>
